// initial state
const baseName = '/admin/api/analysis'

const analysisSimpleInfo = baseName + '/simpleInfo'
const analysisCountDataTotal= baseName + '/orderMoneyCountDataTotal'
const a = Object.assign({analysisSimpleInfo,analysisCountDataTotal})
export default a